<template>
  <Flex
    center
    :class="{ 'cursor-pointer hover:bg-cockpit-green/10 hover:text-cockpit-green': !disabled, 'bg-cockpit-elevated opacity-60': disabled }"
    class="w-[42px] min-w-[42px] h-full border-cockpit-line text-cockpit-muted transition-colors">
    <IconSolid :icon="props.icon" />
  </Flex>
</template>

<script setup>
const props = defineProps({
  icon: String,
  disabled: Boolean,
})
</script>
